<template>
	<div class="bar-loader">
		<div class="fill" :style="'width:'+current.toPrecision(2)+'%'"></div>
	</div>
</template>

<script>
	export default {
		name: "BarLoader",
		props: {
			current: Number
		}
	};
</script>

<style lang="scss" scoped>
	.bar-loader{
		width: 100%;
		height: 15px;
		background-color: #ebebeb;
		border-radius: 5px;
		position: relative;
		overflow: hidden;
		.fill{
			height: 15px;
			background-color: #368bce;
			position: absolute;
			top: 0;
			left: 0;
		}
	}
</style>
